"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var PluggableElementBase_1 = __importDefault(require("./PluggableElementBase"));
var ViewType = /*#__PURE__*/function (_PluggableElementBase) {
  _inherits(ViewType, _PluggableElementBase);
  function ViewType(stuff) {
    var _this;
    _classCallCheck(this, ViewType);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ViewType).call(this, stuff));
    _this.displayTypes = [];
    _this.ReactComponent = stuff.ReactComponent;
    _this.stateModel = stuff.stateModel;
    _this.extendedName = stuff.extendedName;
    if (!_this.ReactComponent) {
      throw new Error("no ReactComponent defined for view ".concat(_this.name));
    }
    if (!_this.stateModel) {
      throw new Error("no stateModel defined for view ".concat(_this.name));
    }
    return _this;
  }
  _createClass(ViewType, [{
    key: "addDisplayType",
    value: function addDisplayType(display) {
      this.displayTypes.push(display);
    }
  }]);
  return ViewType;
}(PluggableElementBase_1.default);
exports.default = ViewType;